import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreLabel = '查看更多',
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <span className="w-10 h-10 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center text-xl">
          <i className={icon} aria-hidden="true"></i>
        </span>
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}